export function getCookie(name: string): string | undefined {
    const prefix = `${name}=`;

    const cookie = document.cookie
        .split('; ')
        .find((entry) => entry.startsWith(prefix));

    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : undefined;
}
